/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * 
 * @export
 * @interface ApiBulkAssignee
 */
export interface ApiBulkAssignee {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiBulkAssignee
     */
    ids: Array<number>;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiBulkAssignee
     */
    assignee: ApiAssignmentUser;
}

/**
 * Check if a given object implements the ApiBulkAssignee interface.
 */
export function instanceOfApiBulkAssignee(value: object): value is ApiBulkAssignee {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    return true;
}

export function ApiBulkAssigneeFromJSON(json: any): ApiBulkAssignee {
    return ApiBulkAssigneeFromJSONTyped(json, false);
}

export function ApiBulkAssigneeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBulkAssignee {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'assignee': ApiAssignmentUserFromJSON(json['assignee']),
    };
}

export function ApiBulkAssigneeToJSON(json: any): ApiBulkAssignee {
    return ApiBulkAssigneeToJSONTyped(json, false);
}

export function ApiBulkAssigneeToJSONTyped(value?: ApiBulkAssignee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'assignee': ApiAssignmentUserToJSON(value['assignee']),
    };
}

